import inlineWorker from '__inline-worker'
export default function Worker() {
  return inlineWorker("function a(s){let t=s.currentTarget;if(t.readyState===XMLHttpRequest.DONE){if(t.status===200)postMessage(t.response);else if(t.status===500||t.status===400||t.status===403||t.status===404)throw Error(t.response)}}onmessage=function(t){let e=new XMLHttpRequest;e.open(\"GET\",t.data),e.onreadystatechange=a,e.send()};\n");
}
